var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIBotNav03On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_149_568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3301 16.6744L18.8638 14.8788C18.6301 14.5919 18.5026 14.2413 18.4813 13.8694L18.3007 8.74815C18.1944 5.63503 15.9313 2.91503 12.8501 2.51128C9.07819 2.02253 5.83756 4.87003 5.69944 8.53565L5.50819 13.8694C5.49756 14.2413 5.35944 14.5919 5.12569 14.8788L3.65944 16.6744C3.24506 17.1738 3.60631 17.9388 4.25444 17.9388H19.7032C20.3513 17.9388 20.7126 17.1844 20.2982 16.6744H20.3301Z",
    fill: "#10141A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04614 17.9281C9.04614 19.5219 10.3955 20.8819 11.9999 20.8819C13.6043 20.8819 14.9536 19.5325 14.9536 17.9281",
    fill: "#10141A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_149_568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 18.4237,
    fill: "white",
    transform: "translate(3.5 2.45813)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIBotNav03On);
export default __webpack_public_path__ + "static/media/i_bot_nav_03_on.78d813819c1d20627079bcf02fef3ee6.svg";
export { ForwardRef as ReactComponent };